import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setScroll } from '../../modules/manageScrollPosition';
import { BackToTopButtonWrapper } from './BackToTopButton.css';
import { easeInOutQuint, scrollToY } from '../../helpers/animatedScrolling';

const mapStateToProps = ({ api: { s3BasePath }, footerWrapper, scrollPosition }) => {
  return {
    footerWrapper,
    s3BasePath,
    scrollPosition,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setScrollPosition: position => {
      dispatch(setScroll(position));
    },
  };
};

class BackToTopButton extends React.Component {
  constructor() {
    super();
    this.renderBackToTopButton = this.renderBackToTopButton.bind(this);
    this.state = { showBackToTop: false };
  }

  componentDidMount() {
    const { scrollPosition } = this.props;
    window.addEventListener('scroll', this.renderBackToTopButton);

    if (scrollPosition) {
      this.scrollTo(scrollPosition);
    }
  }

  componentWillUnmount() {
    if (typeof page !== 'undefined') {
      this.props.setScrollPosition(page.scrollTop);
    }
    window.removeEventListener('scroll', this.renderBackToTopButton);
  }

  scrollTo(scrollPosition) {
    scrollToY(scrollPosition, 1500, easeInOutQuint);
  }

  renderBackToTopButton() {
    const scrollTop = window.scrollY;

    if (scrollTop > 400) {
      this.setState({ showBackToTop: true });
    } else {
      this.setState({ showBackToTop: false });
    }
  }

  render() {
    const { s3BasePath } = this.props;
    const { showBackToTop } = this.state;
    return (
      <div>
        {showBackToTop ? (
          <BackToTopButtonWrapper
            data-cy="button-scroll-to-top"
            onClick={() => this.scrollTo(0)}
            path={`${s3BasePath}mkt/icon/caret-up.png`}
          />
        ) : null}
      </div>
    );
  }
}

BackToTopButton.propTypes = {
  footerWrapper: PropTypes.any,
  s3BasePath: PropTypes.string.isRequired,
  scrollPosition: PropTypes.any,
  setScrollPosition: PropTypes.func.isRequired,
};

BackToTopButton = connect(mapStateToProps, mapDispatchToProps)(BackToTopButton);
export default BackToTopButton;
